import { Image } from '../models/Item'

export const getFeaturedPhoto = (imageObjectArray: Image[]) => {
  if (imageObjectArray) {
    return imageObjectArray.find(obj => obj.position === 0)!.thumbImageUrl
  }
}
